export default "__VITE_ASSET__FdA_1Adt__"